import React from 'react';

const AddQR = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_7_4304"
      // @ts-ignore
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <rect width="14" height="14" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7_4304)">
      <path
        d="M2.91667 8.16667V7H4.08333V8.16667H2.91667ZM1.75 7V5.83333H2.91667V7H1.75ZM7 2.91667V1.75H8.16667V2.91667H7ZM2.625 4.375H4.375V2.625H2.625V4.375ZM1.75 5.25V1.75H5.25V5.25H1.75ZM2.625 11.375H4.375V9.625H2.625V11.375ZM1.75 12.25V8.75H5.25V12.25H1.75ZM9.625 4.375H11.375V2.625H9.625V4.375ZM8.75 5.25V1.75H12.25V5.25H8.75ZM5.25 8.16667V7H4.08333V5.83333H6.41667V8.16667H5.25ZM5.83333 5.25V2.91667H7V4.08333H8.16667V5.25H5.83333ZM3.0625 3.9375V3.0625H3.9375V3.9375H3.0625ZM3.0625 10.9375V10.0625H3.9375V10.9375H3.0625ZM10.0625 3.9375V3.0625H10.9375V3.9375H10.0625ZM9.33333 12.25V10.5H7.58333V9.33333H9.33333V7.58333H10.5V9.33333H12.25V10.5H10.5V12.25H9.33333Z"
        fill="#6930CA"
      />
    </g>
  </svg>
);

export default AddQR;
